import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import context from '../context/recipesContext';

function SearchBar(props) {
  const { setFilterDrinks, setFilterFoods, foods, drinks } = useContext(context);
  const { page } = props;
  const [values, setValues] = useState({ value: '', filter: 'name' });
  const history = useHistory();

  const handleChange = ({ target }) => setValues({ ...values, value: target.value });
  const handleChecked = ({ target }) => {
    if (target.checked) setValues({ ...values, filter: target.value });
  };

  useEffect(() => {
    if (foods.length === 1) history.push(`/foods/${foods[0].idMeal}`);
    if (drinks.length === 1) history.push(`/drinks/${drinks[0].idDrink}`);
    setValues({ value: '', filter: 'name' });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [foods, drinks]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (values.filter === 'fLetter' && values.value.length > 1) {
      global.alert('Your search must have only 1 (one) character');
    } else {
      if (page === 'foods') setFilterFoods(values);
      if (page === 'drinks') setFilterDrinks(values);
    }
  };

  return (
    <div className="search-bar">
      <div>
        <label htmlFor="ingredient" className="search-label">
          Ingredient
          <input
            className="search-radio"
            id="ingredient"
            name="filter"
            onChange={ handleChecked }
            value="ingredient"
            type="radio"
            data-testid="ingredient-search-radio"
          />
        </label>
        <label htmlFor="name" className="search-label">
          Name
          <input
            id="name"
            name="filter"
            className="search-radio"
            onChange={ handleChecked }
            value="name"
            type="radio"
            data-testid="name-search-radio"
          />
        </label>
        <label htmlFor="fLetter" className="search-label">
          First letter
          <input
            id="fLetter"
            name="filter"
            className="search-radio"
            onChange={ handleChecked }
            value="fLetter"
            type="radio"
            data-testid="first-letter-search-radio"
          />
        </label>
      </div>
      <div>
        <input
          className="search-input"
          data-testid="search-input"
          type="text"
          placeholder="search food"
          value={ values.value }
          onChange={ handleChange }
        />
        <button
          className="search-btn"
          type="button"
          data-testid="exec-search-btn"
          onClick={ (event) => handleSubmit(event) }
        >
          Search
        </button>
      </div>
    </div>
  );
}

SearchBar.propTypes = {
  page: PropTypes.string.isRequired,
};

export default SearchBar;
